
import { Options, Vue } from 'vue-class-component'
import LeadService from '@/services/LeadService'
import { Lead } from '@/services/types'

@Options({
  props: {
    mlmId: { type: Number, required: true },
    agentId: { type: Number, required: true },
    rawLeadInput: { type: String, required: true },
  },
  emits: ['success', 'error', 'validated'],
})
export default class LeadValidationBlock extends Vue {
  mlmId!: number
  agentId!: number
  rawLeadInput!: string

  isLoading = false
  showReassign = false
  showSuccessMessage = false
  leadId: number | null = null

  public async startValidation() {
    console.log('Start Validation...')
    if (this.isLoading || this.showSuccessMessage || this.showReassign) return

    console.log('Start Lead Validation...')
    const leadId = this.extractLeadId(this.rawLeadInput)
    if (leadId === null) {
      this.$emit('error', new Error('Некорректная ссылка или номер лида'))
      return
    }

    this.leadId = leadId
    this.isLoading = true
    this.showReassign = false
    this.showSuccessMessage = false

    try {
      const response = await LeadService.getLeadById(leadId)
      const lead: Lead = response.data
      if (lead.mlm_id === this.mlmId) {
        this.$emit('success', leadId)
      } else {
        this.showReassign = true
      }
    } catch (e: any) {
      if (e?.response?.status === 404) {
        this.$emit('error', new Error('Лид не найден в системе'))
      } else {
        this.$emit('error', e)
      }
    } finally {
      this.isLoading = false
    }
  }

  public reset() {
    this.isLoading = false
    this.showReassign = false
    this.showSuccessMessage = false
    this.leadId = null
  }

  async changeOwner() {
    if (!this.leadId) return

    this.isLoading = true
    try {
      await LeadService.changeLeadOwner(this.leadId, this.agentId)
      this.showReassign = false
      this.showSuccessMessage = true

      this.$emit('validated', this.leadId)
    } catch (e: any) {
      this.$emit('error', e)
    } finally {
      this.isLoading = false
    }
  }

  extractLeadId(input: string): number | null {
    const trimmed = input.trim()
    if (/^\d+$/.test(trimmed)) return parseInt(trimmed, 10)

    try {
      const url = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`)
      const parts = url.pathname.split('/').filter(Boolean)
      const last = parts[parts.length - 1]
      if (last && /^\d+$/.test(last)) return parseInt(last, 10)
    } catch {}

    return null
  }
}
